<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="page--login d-flex justify-center align-center">
          <div class="form-container">
            <v-card class="pa-10">
              <v-form ref="form">
                <v-row>
                  <v-col class="text-center">
                    <img
                      class="svgLogoPernambuco"
                      src="https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_branco_c2003fd940.png"
                      alt="Brasão do state de Pernambuco"
                    />
                    <br />
                    <h1
                      class="subtitle-1 blue--text text--darken-4"
                      color="primary"
                      v-text="$appName || 'Acessar o Sistema'"
                    ></h1>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="text-center">
                      <h4
                        class="subtitle-2 blue--text"
                        color="primary"
                        v-text="'Primeiro Acesso'"
                      ></h4>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      solo
                      v-model="form.senha.value"
                      placeholder="Nova senha"
                      maxlength="8"
                      @keyup.enter="enter"
                      @click:append="form.senha.show = !form.senha.show"
                      :append-icon="form.senha.show ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="form.senha.show ? 'text' : 'password'"
                      :rules="regrasDaSenha"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      solo
                      v-model="form.confirmacaoSenha.value"
                      placeholder="Confirme a nova senha"
                      maxlength="8"
                      @keyup.enter="enter"
                      @click:append="form.confirmacaoSenha.show = !form.confirmacaoSenha.show"
                      @paste.prevent
                      :append-icon="form.confirmacaoSenha.show ? 'mdi-eye-off' : 'mdi-eye'"
                      :type="form.confirmacaoSenha.show ? 'text' : 'password'"
                      :rules="regrasDaSenha"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-card>
                      <span>Sua senha deve ter 8 caracteres e ser composta por pelo menos:</span>
                      <ul class="mt-1">
                        <li v-for="(item, index) in getInformacoesDasRegras()" :key="index" class="mt-2">
                          <v-icon :color="item.valid(form) ? 'success' : 'warning'" class="mr-1">
                            {{ item.icon(item.valid(form)) }}
                          </v-icon> {{ item.text }}
                        </li>
                      </ul>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row class="text-center">
                  <v-col cols="12">
                    <v-btn
                      block
                      color="success"
                      :loading="loading"
                      @click.prevent="enviar"
                    >
                      Enviar
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-btn color="info" small rounded outlined @click.prevent="voltar">Voltar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CLEAR } from "store";

export default {
  data: () => ({
    loading: false,
    form: {
      senha: {
        show: false,
        value: undefined
      },
      confirmacaoSenha: {
        show: false,
        value: undefined
      },
    },

  }),
  computed: {
    regrasDaSenha() {
      return [(v) => this.$required(v), (v) => this.$min(v, 8), (v) => this.$max(v, 8)];
    },
    possuiMesmasSenhas() {
      return this.form.senha.value === this.form.confirmacaoSenha.value;
    }
  },
  beforeMount() {
    this.$store.dispatch(CLEAR);
  },
  methods: {
    getInformacoesDasRegras() {
      return [
        {
          text: '01 letra maiúscula;',
          valid: (form) => /[A-Z]/.test(form.senha.value) && /[A-Z]/.test(form.confirmacaoSenha.value),
          icon: (v) => `mdi-${v ? 'check' : 'alert'}-circle`
        },
        {
          text: '01 letra minúscula;',
          valid: (form) => (form.senha.value && form.confirmacaoSenha.value) && /[a-z]/.test(form.senha.value) && /[a-z]/.test(form.confirmacaoSenha.value),
          icon: (v) => `mdi-${v ? 'check' : 'alert'}-circle`
        },
        {
          text: '01 número;',
          valid: (form) => /[\d]/.test(form.senha.value) && /[\d]/.test(form.confirmacaoSenha.value),
          icon: (v) => `mdi-${v ? 'check' : 'alert'}-circle`
        },
        {
          text: '01 caractere especial.',
          valid: (form) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(form.senha.value) && /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(form.confirmacaoSenha.value),
          icon: (v) => `mdi-${v ? 'check' : 'alert'}-circle`
        }
      ]
    },
    enviar() {
      if (this.$validarFormulario("Todos os campos são de preenchimento obrigatório")) {
        if (!this.getInformacoesDasRegras().every(item => item.valid(this.form))) {
          return this.$notifyError("A nova senha deve ter 8 caracteres e ser composta de pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial. Por favor, verifique o campo preenchido e tente novamente.");
        }
        if (!this.possuiMesmasSenhas) {
          return this.$notifyError("As senhas inseridas nos campos 'Nova Senha' e 'Confirme a nova senha' não são iguais. Por favor, verifique e tente novamente.");
        }
        this.loading = true;
        const objEnvio = {
          nomeDeUsuario: this.$route.params.cpf,
          senha: this.form.senha.value,
          confirmarSenha: this.form.confirmacaoSenha.value,
          token: this.$route.params.token
        }
        this.$mudarSenha(objEnvio).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.voltar();
        }).catch(({ data }) => {
          this.$notifyError(data.mensagem);
          this.$store.dispatch(CLEAR);
        });
      }
    },
    voltar() {
      this.$router.push({ path: '/login' })
    }
  }
};
</script>

<style lang="scss" scoped>
.svgLogoPernambuco{
  width: "476px";
  height: "126px";
}
.page--login {
  min-height: calc(100vh - 24px) !important;
  .form-container {
    form {
      min-width: 250px;
      a {
        text-decoration: none;
      }
    }
  }
}
li {
  list-style: none;
}
</style>
